module.exports = __webpack_public_path__ + "img/vendas-link.ef1479ea.svg";